export default "__VITE_ASSET__DX_$JgHT__"